module.exports = __webpack_public_path__ + "static/img/DE.406339b8.png";